export default "__VITE_ASSET__80e1a881__"